<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KTextField from '@/components/fields/KTextField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  name?: string;
  reason?: string;
}

export interface ValidData {
  name?: string;
  reason: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
  isFutile?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
  isFutile: undefined,
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.reason == null) return;
  const validData: ValidData = {
    name: formData.name,
    reason: formData.reason,
  };
  emit('submit', event, validData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.cancelCloseStopDialogForm"
    data-testid="cancelCloseStopDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KTextField
      v-if="!props.isFutile"
      v-model="formData.name"
      label="Name"
      :disabled="props.loading"
      :class="$style.field"
    />
    <KTextField
      v-model="formData.reason"
      label="Reason"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.cancelCloseStopDialogForm {
}
  .field {
  }
</style>
